/** @flow */

import { all, put, takeEvery, call, takeLatest } from "redux-saga/effects";
import type { Action } from "redux-action";
import http from "@http";
import config from "@config";
import { ExportFullList, ExportFullListSuccess } from "@modules/hierarchy/constants/actions";
import actionCreators from "@modules/hierarchy/actionCreator";
import { downloadCsvFile } from "@sagas/utils";

type ExportFullListRequest = $Exact<{
  clientId: string,
  page?: number,
}>;

export function* onExportFullList({
  payload,
}: Action<ExportFullListRequest>): Generator<*, void, Object> {
  if (!payload || !payload.clientId) {
    throw Error("Invalid payload provided");
  }

  try {
    const result = yield call(
      http.get,
      `${config.endpointBaseUrl}api/v1/hierarchy-admin/client/${payload.clientId}/hierarchy/recipients`,
    );

    yield put(actionCreators.ExportFullListSuccess(result.data || ""));
  } catch (e) {
    yield put(actionCreators.ExportFullListError(e.response));
  }
}

export function* onExportFullListSuccess({ payload }: Action<any>): Generator<*, void, any> {
  yield downloadCsvFile(payload, "summary-list.csv");
}

export function* DepartmentContactsSagas(): Generator<*, void, void> {
  yield all([
    takeEvery(ExportFullList, onExportFullList),
    takeLatest(ExportFullListSuccess, onExportFullListSuccess),
  ]);
}

export default DepartmentContactsSagas;
